const vtoken = import.meta.env.VITE_TOKEN;
import { COMMITTEE_KEYS } from '@/utils/constant';
import contactService from '@/services/contact';
import { useAuthStore } from '@/stores/auth.js';
import { useLoaderStore } from '@/stores/loader';

// Route name do not need permissions
// const whiteList = []

export async function middlewareLayout(to, from, next) {
	try {
		const layout = to.meta.layout ?? 'Default';
		const theme = await import(`@/layouts/${layout}.vue`);
		to.meta.theme = theme.default;

		let loaderStore;
		try {
			loaderStore = useLoaderStore();
		} catch (err) {
			console.warn('Pinia not ready, skipping loader store');
			loaderStore = null;
		}
		const committeeToken = localStorage.getItem(COMMITTEE_KEYS.vtoken);

		const committeePages = {
			public: ['CommitteeLogin'],
			private: ['CommitteeHome'],
		};
		committeePages.allPages = [...committeePages.public, ...committeePages.private];

		// survey route
		const { key, hash, status, session_id, eps_token } = to.query;
		if (key && hash && status && session_id) {
			if (status === 'success') {
				if (loaderStore) loaderStore.toggleLoader(true);
				try {
					await contactService.getPaymentSuccess(key, hash, session_id);
					if (loaderStore) loaderStore.toggleLoader(false);
				} catch (err) {
					if (loaderStore) loaderStore.toggleLoader(false);
				}
			}
		}

		// handle authen Register or Home
		if (eps_token) {
			try {
				if (loaderStore) loaderStore.toggleLoader(true);
				const { data } = await contactService.auth(eps_token);
				if (data?.token) {
					useAuthStore().setUser(data);
					useAuthStore().setDeanUser(data.dean);
					if (loaderStore) loaderStore.toggleLoader(false);
					// redirect Home , if exist school_contact
					if (data?.school_contact && to.name !== 'Home') {
						return next({ name: 'Home' });
					} else return next();
				} else {
					if (to.name !== 'Register') {
						return next({ name: 'Register' });
					} else next();
				}
			} catch (err) {
				if (loaderStore) loaderStore.toggleLoader(false);
				if (to.name !== 'Register') {
					return next({ name: 'Register' });
				} else next();
			}
		} else if (committeePages.allPages.includes(to.name)) {
			if (!committeeToken) {
				if (committeePages.private.includes(to.name)) {
					return next({ name: 'CommitteeLogin' });
				} else return next();
			}

			if (committeePages.public.includes(to.name)) {
				return next({ name: 'CommitteeHome' });
			}

			return next();
		} else {
			const token = localStorage.getItem(vtoken);
			if (token) {
				return next();
			} else {
				if (to.name !== 'Register') {
					return next({ name: 'Register' });
				} else next();
			}
		}
	} catch (e) {
		console.log(e);
		const theme = await import(`@/layouts/Default.vue`);
		to.meta.theme = theme.default;
	}
}
